/**
 * Returns the indication when it is one of the client's configured indication options; otherwise undefined.
 */
export const reconcileIndicationFilter = (
  indication: string | null | undefined,
  indicationOptions: ReadonlyArray<{ value: string }> | undefined,
): string | undefined =>
  indication && indicationOptions?.some((option) => option.value === indication) ? indication : undefined;
